import Phaser from 'phaser';
import BootScene from './scenes/BootScene';
import PreloadScene from './scenes/PreloadScene';
import TitleScene from './scenes/TitleScene';
import CameraSetupScene from './scenes/CameraSetupScene';
import CalibrationScene from './scenes/CalibrationScene';
import BattleScene from './scenes/BattleScene';
import AnalysisScene from './scenes/AnalysisScene';
import LeaderboardScene from './scenes/LeaderboardScene';
import LoginScene from './scenes/LoginScene';
import ShopScene from './scenes/ShopScene';
import PVPScene from './scenes/PVPScene';
import { initInputs } from './utils/inputs';

// Initialize embedded HTML inputs BEFORE Phaser game
initInputs();

const config: Phaser.Types.Core.GameConfig = {
  type: Phaser.AUTO,
  width: 1280,
  height: 720,
  parent: 'game-container',
  backgroundColor: '#0a0a1a',
  scale: {
    mode: Phaser.Scale.FIT,
    autoCenter: Phaser.Scale.CENTER_BOTH,
  },
  scene: [
    BootScene,
    PreloadScene,
    TitleScene,
    CameraSetupScene,
    CalibrationScene,
    BattleScene,
    AnalysisScene,
    LeaderboardScene,
    LoginScene,
    ShopScene,
    PVPScene,
  ],
  physics: {
    default: 'arcade',
    arcade: {
      gravity: { x: 0, y: 800 },
      debug: false,
    },
  },
};

const game = new Phaser.Game(config);

// Expose to window for scene access
(window as any).game = game;

export default game;
